import config from '../config.json';

export interface RouteMetaProps {
    name: string;
    url: string;
    visible?: boolean;
    protected?: boolean;
    code: string;
    type: string;
}

export const routesMeta: Array<RouteMetaProps> = [
    {
        name: 'Úvodní volba',
        url: '/',
        protected: true,
        code: 'STEP0',
        type: 'default',
    },
    {
        name: 'Základní informace o vás',
        url: `/${config.SLUGS.STEP1A_SLUG}/`,
        protected: true,
        code: 'STEP1',
        type: config.INCOME_CODE,
    },
    {
        name: 'Informace o hypotéce',
        url: `/${config.SLUGS.STEP1B_SLUG}/`,
        protected: true,
        code: 'STEP1',
        type: config.MORTGAGE_CODE,
    },
    {
        name: 'Přes online to nepůjde',
        visible: false,
        url: `/${config.SLUGS.STEP1C_SLUG}/`,
        protected: true,
        code: 'STEP1',
        type: 'default',
    },
    {
        name: 'Doporučené pojištění',
        url: `/${config.SLUGS.STEP2A_SLUG}/`,
        protected: true,
        code: 'STEP2',
        type: config.INCOME_CODE,
    },
    {
        name: 'Úvěrový balíček',
        url: `/${config.SLUGS.STEP2B_SLUG}/`,
        protected: true,
        code: 'STEP2',
        type: config.MORTGAGE_CODE,
    },
    {
        name: 'Pojištění navíc',
        url: `/${config.SLUGS.STEP3_SLUG}/`,
        protected: true,
        code: 'STEP3',
        type: 'default',
    },
    {
        name: 'Něco o vás',
        url: `/${config.SLUGS.STEP4_SLUG}/`,
        protected: true,
        code: 'STEP4',
        type: 'default',
    },
    {
        name: 'Ještě něco o vás',
        url: `/${config.SLUGS.STEP5_SLUG}/`,
        protected: true,
        code: 'STEP5',
        type: 'default',
    },
    {
        name: 'Nemoci',
        url: `/${config.SLUGS.STEP6_SLUG}/`,
        protected: true,
        code: 'STEP6',
        type: 'default',
    },
    {
        name: 'Úrazy',
        url: `/${config.SLUGS.STEP7_SLUG}/`,
        protected: true,
        code: 'STEP7',
        type: 'default',
    },
    {
        name: 'Poslední informace o vás',
        url: `/${config.SLUGS.STEP8_SLUG}/`,
        protected: true,
        code: 'STEP8',
        type: 'default',
    },
    {
        name: 'Vyhodnocení zdravotního dotazníku',
        visible: false,
        url: `/${config.SLUGS.STEP9LOADING_SLUG}/`,
        protected: true,
        code: 'STEP9LOADING',
        type: 'default',
    },
    {
        name: 'BankID',
        url: `/${config.SLUGS.STEP9_SLUG}/`,
        protected: true,
        code: 'STEP9',
        type: 'default',
    },
    {
        name: 'Nemůžeme vás pojistit',
        visible: false,
        url: `/${config.SLUGS.STEP9A_SLUG}/`,
        protected: true,
        code: 'STEP9A',
        type: 'default',
    },
    {
        name: 'Přes online to nepůjde',
        visible: false,
        url: `/${config.SLUGS.STEP9B_SLUG}/`,
        protected: true,
        code: 'STEP9B',
        type: 'default',
    },
    {
        name: 'Upravení nabídky',
        visible: false,
        url: `/${config.SLUGS.STEP9C_SLUG}/`,
        protected: true,
        code: 'STEP9C',
        type: 'default',
    },
    {
        name: 'BankID',
        visible: false,
        url: `/${config.SLUGS.STEP_BANK_ID_SLUG}/`,
        protected: true,
        code: 'STEP_BANKID',
        type: 'default',
    },
    {
        name: 'Potvrzení údajů',
        url: `/${config.SLUGS.STEP_CONFIRMDATA_SLUG}/`,
        protected: true,
        code: 'STEP_CONFIRMDATA',
        type: 'default',
    },
    {
        name: 'Zpracování',
        visible: false,
        url: `/${config.SLUGS.STEP10PROCESSING_SLUG}/`,
        protected: true,
        code: 'STEP10PROCESSING',
        type: 'default',
    },
    {
        name: 'Platební údaje',
        url: `/${config.SLUGS.STEP10_SLUG}/`,
        protected: true,
        code: 'STEP10',
        type: 'default',
    },
    {
        name: 'Vítejte u nás',
        visible: true,
        url: `/${config.SLUGS.STEP11_SLUG}/`,
        protected: true,
        code: 'STEP11',
        type: 'default',
    },
    {
        name: 'Vstup klienta',
        visible: false,
        url: `/${config.SLUGS.STEP_LEAD_SLUG}/`,
        protected: true,
        code: 'STEP_LEAD',
        type: 'default',
    },
    {
        name: 'Nemáte přístup',
        visible: false,
        url: `/${config.SLUGS.NOENTRY_SLUG}/`,
        code: 'NOENTRY',
        type: 'default',
    },
    {
        name: 'Stránka neexistuje',
        visible: false,
        url: '*',
        code: 'NOTFOUND',
        type: 'default',
    },
    {
        name: 'Chyba na serveru',
        visible: false,
        url: `/${config.SLUGS.SERVERERR_SLUG}/`,
        code: 'SERVERERR',
        type: 'default',
    },
    {
        name: 'Test',
        visible: false,
        url: `/${config.SLUGS.TEST}/`,
        code: 'TEST',
        type: 'default',
    },
];
